export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8224.de309a5d.jpg";